module.exports = __webpack_public_path__ + "static/media/stripe-onboarding_7.a30c6819.png";